<script>
  import SidePanel from "../components/sidePanel/SidePanel.svelte";
  import SidePanelLinkCard from "../components/sidePanel/SidePanelLinkCard.svelte";
  import SidePanelSplitter from "../components/sidePanel/SidePanelSplitter.svelte";
  import { getAutoAssemblyProjectContext } from "./AutoAssemblyProjectContext.js";

  const ctx = getAutoAssemblyProjectContext()
  const projectId = $ctx.projectId
</script>

<div class="root">
  <SidePanel>
    <img src="/assets/logo_asprova.png" alt="logo asprova"/>
    <div style="font-weight: bold; font-size: 1.2rem;">
      Asprova Auto Assembly
    </div>
    <SidePanelSplitter />
    <SidePanelLinkCard
      href={`/auto-assembly/projects/${projectId}/plans/1`}
      backgroundColor="#00468f"
      textColor="white"
      title="平準化する"
    />
    <SidePanelSplitter />
    <SidePanelLinkCard
      href={`/auto-mps/projects/${projectId}`}
      title="オーダテーブル"
    />
    <SidePanelLinkCard
      href={`/auto-mps/projects/${projectId}`}
      title="仕様テーブル"
    />
    <SidePanelLinkCard
      href={`/auto-mps/projects/${projectId}`}
      title="エクスポートする"
    />
  </SidePanel>
  <div class="main">
    <slot/>
  </div>
</div>

<style>
  .root {
    display: flex;
    height: 100%;
    max-width: 100vw;
  }

  .main {
    flex: 1;
    min-width: 0;
    max-height: 100%;
    overflow-y: auto;
    scrollbar-width: thin;
    background-color: white;
  }
</style>
